import React, { memo } from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
export const RiskFactorsSection = () => {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-378">
      <div className="container mx-auto px-4 md:px-6" data-id="element-379">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-indigo-900 mb-12" data-id="element-380">
          The Hidden Dangers of Sleeping Pills (And Why Sleep Restore is Safer)
        </h2>
        <div className="max-w-4xl mx-auto bg-indigo-50 p-6 rounded-lg mb-10" data-id="element-381">
          <div className="flex flex-col md:flex-row justify-between" data-id="element-382">
            <div className="md:w-1/2 p-4" data-id="element-383">
              <h3 className="text-xl font-bold text-red-800 mb-3" data-id="element-384">
                Sleeping Pills
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-385">
                Force your brain into unconsciousness, bypassing natural sleep
                cycles and causing dependency
              </p>
              <div className="h-2 w-full bg-red-200 rounded-full mb-2" data-id="element-386"></div>
              <div className="h-2 w-3/4 bg-red-200 rounded-full mb-2" data-id="element-387"></div>
              <div className="h-2 w-1/2 bg-red-200 rounded-full" data-id="element-388"></div>
            </div>
            <div className="md:w-1/2 p-4 mt-6 md:mt-0" data-id="element-389">
              <h3 className="text-xl font-bold text-indigo-800 mb-3" data-id="element-390">
                Sleep Restore Strips
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-391">
                Support your body's natural sleep hormone production for
                restorative, healthy sleep
              </p>
              <div className="h-2 w-full bg-indigo-200 rounded-full mb-2" data-id="element-392"></div>
              <div className="h-2 w-3/4 bg-indigo-200 rounded-full mb-2" data-id="element-393"></div>
              <div className="h-2 w-1/2 bg-indigo-200 rounded-full" data-id="element-394"></div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-395">
          <div className="bg-red-50 rounded-lg p-6 md:p-8" data-id="element-396">
            <div className="flex items-center mb-6" data-id="element-397">
              <div className="bg-red-100 rounded-full p-2 mr-3" data-id="element-398">
                <XIcon className="h-6 w-6 text-red-600" data-id="element-399" />
              </div>
              <h3 className="text-xl font-bold text-red-800" data-id="element-400">
                Sleeping Pills: The Risks They Don't Tell You
              </h3>
            </div>
            <div className="mb-6 bg-white p-4 rounded-lg" data-id="element-401">
              <div className="flex items-center justify-center" data-id="element-402">
                <div className="text-center" data-id="element-403">
                  <div className="inline-block bg-red-100 p-3 rounded-full mb-2" data-id="element-404">
                    <XIcon className="h-8 w-8 text-red-600" data-id="element-405" />
                  </div>
                  <p className="text-red-800 font-medium" data-id="element-406">
                    Disrupts Natural Sleep Cycles
                  </p>
                </div>
              </div>
            </div>
            <ul className="space-y-4" data-id="element-407">
              <li className="flex" data-id="element-408">
                <XIcon className="h-5 w-5 text-red-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-409" />
                <div data-id="element-410">
                  <span className="font-medium text-gray-900" data-id="element-411">
                    Physical Dependence:
                  </span>
                  <p className="text-gray-700" data-id="element-412">
                    Your body stops producing natural sleep chemicals, making it
                    impossible to sleep without pills.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-413">
                <XIcon className="h-5 w-5 text-red-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-414" />
                <div data-id="element-415">
                  <span className="font-medium text-gray-900" data-id="element-416">
                    Next-Day Impairment:
                  </span>
                  <p className="text-gray-700" data-id="element-417">
                    Studies show sleeping pill users have 2x higher risk of car
                    accidents due to morning grogginess.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-418">
                <XIcon className="h-5 w-5 text-red-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-419" />
                <div data-id="element-420">
                  <span className="font-medium text-gray-900" data-id="element-421">
                    Memory Problems:
                  </span>
                  <p className="text-gray-700" data-id="element-422">
                    Regular use can impair memory formation and cognitive
                    function.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-423">
                <XIcon className="h-5 w-5 text-red-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-424" />
                <div data-id="element-425">
                  <span className="font-medium text-gray-900" data-id="element-426">
                    Tolerance Buildup:
                  </span>
                  <p className="text-gray-700" data-id="element-427">
                    You need higher doses over time, leading to a dangerous
                    cycle.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-428">
                <XIcon className="h-5 w-5 text-red-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-429" />
                <div data-id="element-430">
                  <span className="font-medium text-gray-900" data-id="element-431">
                    Rebound Insomnia:
                  </span>
                  <p className="text-gray-700" data-id="element-432">
                    Stop taking them, and your sleep becomes worse than before
                    you started.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-433">
                <XIcon className="h-5 w-5 text-red-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-434" />
                <div data-id="element-435">
                  <span className="font-medium text-gray-900" data-id="element-436">
                    Drug Interactions:
                  </span>
                  <p className="text-gray-700" data-id="element-437">
                    Can be dangerous when combined with other medications or
                    alcohol.
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div className="bg-indigo-50 rounded-lg p-6 md:p-8" data-id="element-438">
            <div className="flex items-center mb-6" data-id="element-439">
              <div className="bg-indigo-100 rounded-full p-2 mr-3" data-id="element-440">
                <CheckIcon className="h-6 w-6 text-indigo-600" data-id="element-441" />
              </div>
              <h3 className="text-xl font-bold text-indigo-800" data-id="element-442">
                Setu Sleep Restore: The Natural Alternative
              </h3>
            </div>
            <div className="mb-6 bg-white p-4 rounded-lg flex items-center justify-center" data-id="element-443">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/og45cR6GEKB2RvPaD1aJ2B/Screenshot_2025-08-25_at_9.01.12_PM.png" alt="Sleep Restore Melatonin Strips" className="h-48 object-contain rounded-lg" data-id="element-444" />
            </div>
            <ul className="space-y-4" data-id="element-445">
              <li className="flex" data-id="element-446">
                <CheckIcon className="h-5 w-5 text-indigo-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-447" />
                <div data-id="element-448">
                  <span className="font-medium text-gray-900" data-id="element-449">
                    Works with Your Body:
                  </span>
                  <p className="text-gray-700" data-id="element-450">
                    Supports natural melatonin production rather than replacing
                    it.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-451">
                <CheckIcon className="h-5 w-5 text-indigo-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-452" />
                <div data-id="element-453">
                  <span className="font-medium text-gray-900" data-id="element-454">
                    No Morning Hangover:
                  </span>
                  <p className="text-gray-700" data-id="element-455">
                    Wake up clear-headed and energized, not groggy.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-456">
                <CheckIcon className="h-5 w-5 text-indigo-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-457" />
                <div data-id="element-458">
                  <span className="font-medium text-gray-900" data-id="element-459">
                    Preserves Memory:
                  </span>
                  <p className="text-gray-700" data-id="element-460">
                    Allows natural sleep cycles that are crucial for memory
                    consolidation.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-461">
                <CheckIcon className="h-5 w-5 text-indigo-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-462" />
                <div data-id="element-463">
                  <span className="font-medium text-gray-900" data-id="element-464">
                    No Tolerance Issues:
                  </span>
                  <p className="text-gray-700" data-id="element-465">
                    Effective dose remains consistent over time.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-466">
                <CheckIcon className="h-5 w-5 text-indigo-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-467" />
                <div data-id="element-468">
                  <span className="font-medium text-gray-900" data-id="element-469">
                    Easy to Stop:
                  </span>
                  <p className="text-gray-700" data-id="element-470">
                    No withdrawal symptoms or rebound insomnia when you don't
                    need it.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-471">
                <CheckIcon className="h-5 w-5 text-indigo-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-472" />
                <div data-id="element-473">
                  <span className="font-medium text-gray-900" data-id="element-474">
                    Safe Profile:
                  </span>
                  <p className="text-gray-700" data-id="element-475">
                    Minimal interactions and extensively studied for safety.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
};